var map = {
	"./feedback1-1.jpg": "557e",
	"./feedback10-1.jpg": "87fc",
	"./feedback2-1.jpg": "c424",
	"./feedback3-1.jpg": "4629",
	"./feedback4-1.jpg": "174a",
	"./feedback5-1.jpg": "59f1",
	"./feedback6-1.jpg": "cd18",
	"./feedback7-1.jpg": "c4d5",
	"./feedback8-1.jpg": "13ab",
	"./feedback9-1.jpg": "60d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65f2";